import { toast } from 'sonner'
import { InfoFilledIcon } from '@/components/ui/custom-icons'

/**
 * Shown whenever a shape/text-box/photo commit is reverted for crossing the pasteboard's outer
 * limit (see `isShapeOutsidePasteboardBounds`). One fixed,
 * generic message regardless of object type, how many were reverted, or which UI path (canvas
 * drag in `home.tsx`, or a typed X/Y commit in `object-panel/hooks/use-position-field.ts`)
 * triggered the revert.
 */
export function notifyObjectKeptWithinPasteboard(): void {
  // Stable id: repeated out-of-bounds commits (e.g. re-blurring the same X/Y field) re-fire this
  // on every commit. Without it they stack — see the `chain-locked-edit` toast in
  // shape-manager/hooks/use-chain-text-clipboard.ts for the same fix applied to a held-down key repeat.
  toast.info('Object kept within the pasteboard.', {
    id: 'pasteboard-bounds',
    icon: <InfoFilledIcon size={20} className="text-black" />,
  })
}
